import Layout from '@/layout/base/layoutSegfy'

// "Vitrine de Leads" é o item de menu que vem da auth (chave VITRINE_LEADS, link /vitrine-leads).
// A tela é a integração com a Corretou. O path é /vitrine-leads (casa com o link da auth);
// mantemos /corretou-leads como redirect para não quebrar links/atalhos antigos.
export default [{
  path: '/vitrine-leads',
  component: Layout,
  children: [{
    path: '',
    name: 'corretou-leads',
    component: () => import('@/components/corretou/corretouLeads'),
    meta: {
      auth: true
    }
  }]
}, {
  path: '/corretou-leads',
  redirect: '/vitrine-leads'
}]
